/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';

export const candidateReputationClarificationSchema = z.object({
  candidateId: z.string().uuid(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  opportunityId: z.string().uuid(),
  submissionComments: z.string().nullish(),
  submissionCommentsUpdatedAt: z.string().datetime().nullish(),
  submissionCommentsUpdatedBy: z.string().uuid().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type CandidateReputationClarification = z.infer<typeof candidateReputationClarificationSchema>;
